export class LoginResponseModel {
  accessToken!: string
}
